import { ApiService } from './ApiService'
import { ApiServicePublic } from './ApiServicePublic'
import { ApiServiceSite } from './ApiServiceSite'

export const apiService = new ApiService()
export const apiServicePublic = new ApiServicePublic()
export const apiServiceSite = new ApiServiceSite()
